export const TimeInMS = {
    Second: 1000,
    Minute: 1000 * 60,
    Hour: 1000 * 60 * 60,
    Day: 1000 * 60 * 60 * 24,
    Week: 1000 * 60 * 60 * 24 * 7,
    Month: 1000 * 60 * 60 * 24 * 30,
    Year: 1000 * 60 * 60 * 24 * 365,
  };